// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Ug63","label":"LabeledBox_label__jeAD2"};